import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import sanityClient from "../client.js";
import imageUrlBuilder from "@sanity/image-url";
import SanityBlockContent from "@sanity/block-content-to-react";
import "../css/PostGallery.css"; // Ensure you import the CSS file

const builder = imageUrlBuilder(sanityClient);
function urlFor(source) {
  return builder.image(source);
}

export default function PostGallery() {
  const [postData, setPost] = useState(null);

  useEffect(() => {
    sanityClient
      .fetch(`*[_type == "post"] | order(_createdAt desc){
        title,
        slug,
        mainImage{
          asset->{
            _id,
            url
          },
          crop,
          hotspot,
          alt
        },
        abstract,
        _createdAt
      }`)
      .then((data) => { setPost(data); console.log(data) })
      .catch(console.error);
  }, []);

  if (!postData) return <div>Loading...</div>;

  return (
    <div className="post-gallery-body">
      <div className="post-gallery-container">
        <div className="post-gallery"> 
          <div className="post-gallery-left">
            { postData[0] && 
              <article className="gallery-post-card" key={0}>
                <Link to={"/posts/" + postData[0].slug.current} key={postData[postData.length - 1].slug.current}>
                  <div className="gallery-blogcard-image-container">
                    <img
                      src={urlFor(postData[0].mainImage).width(800).url()}
                      alt={postData[0].mainImage.alt}
                      className="gallery-post-thumbnail"
                    />
                    <div className="overlay-text">
                      <h3 className="gallery-blogcard-title">{postData[0].title}</h3>
                      <div className="gallery-blogcard-abstract">
                        <SanityBlockContent
                          blocks={postData[0].abstract}
                          projectId="066s3bew"
                          dataset="production"
                        />
                      </div>
                    </div>
                  </div>
                </Link>
              </article>
            }
          </div>
          <div className="post-gallery-right">
            { postData.slice(1, 3).map((post, index) => (
              <article className="gallery-post-card" key={index + 1}>
                <Link to={"/posts/" + post.slug.current} key={post.slug.current}>
                  <div className="gallery-blogcard-image-container">
                    <img
                      src={urlFor(post.mainImage).width(800).url()}
                      alt={post.mainImage.alt}
                      className="gallery-post-thumbnail"
                    />
                    <div className="overlay-text">
                      <h3 className="gallery-blogcard-title">{post.title}</h3>
                    </div>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}